import { availabilitiesApi } from '@/admin/api/availabilities';
import { queryOptions } from '@tanstack/react-query';

export const availabilitiesQuery = () =>
	queryOptions({
		queryKey: ['availabilities'] as const,
		queryFn: () => availabilitiesApi.list({ per_page: 1 }),
		staleTime: 5 * 60_000,
		gcTime: 10 * 60_000,
		refetchOnWindowFocus: false,
	});
